export const LoadingSpinner = () => {
  return (
    <>
      <div className="overlay">
        <div className="container">
          <div className="slice"></div>
          <div className="slice"></div>
          <div className="slice"></div>
          <div className="slice"></div>
          <div className="slice"></div>
          <div className="slice"></div>
        </div>

      </div>
      <style>{`
            .overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(30, 60, 114, 0.4);
          filter: blur(4px);
          -webkit-filter: blur(4px);
          z-index: 9999;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
        }
.container {
  width: 200px;
  height: 200px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 20px;
}

.slice {
  position: relative;
  height: 33px; /* 200px / 6 */
  width: 100%;
}

.slice::before,
.slice::after {
  content: "";
  position: absolute;
  top: 0;
  left: calc(50% - 16.67px); /* 200px / 12 */
  height: 100%;
  width: 16.67%; /* 100% / 6 */
  border-radius: 50%;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-animation: orbit 2.5s linear infinite;
  animation: orbit 2.5s linear infinite;
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

.slice:nth-child(1)::after {
  -webkit-animation-delay: -1.25s;
  animation-delay: -1.25s;
}

.slice:nth-child(2)::before {
  -webkit-animation-delay: -0.417s;
  animation-delay: -0.417s;
}

.slice:nth-child(2)::after {
  -webkit-animation-delay: -1.667s;
  animation-delay: -1.667s;
}

.slice:nth-child(3)::before {
  -webkit-animation-delay: -0.834s;
  animation-delay: -0.834s;
}

.slice:nth-child(3)::after {
  -webkit-animation-delay: -2.084s;
  animation-delay: -2.084s;
}

.slice:nth-child(4)::before {
  -webkit-animation-delay: -1.251s;
  animation-delay: -1.251s;
}

.slice:nth-child(4)::after {
  -webkit-animation-delay: -2.501s;
  animation-delay: -2.501s;
}

.slice:nth-child(5)::before {
  -webkit-animation-delay: -1.668s;
  animation-delay: -1.668s;
}

.slice:nth-child(5)::after {
  -webkit-animation-delay: -2.918s;
  animation-delay: -2.918s;
}

.slice:nth-child(6)::before {
  -webkit-animation-delay: -2.085s;
  animation-delay: -2.085s;
}

.slice:nth-child(6)::after {
  -webkit-animation-delay: -3.335s;
  animation-delay: -3.335s;
}

@-webkit-keyframes orbit {
  0% { -webkit-transform: translateX(50px) scale(0.73684); opacity: 0.65; }
  5% { -webkit-transform: translateX(47px) scale(0.684208); opacity: 0.58; }
  10% { -webkit-transform: translateX(36.4px) scale(0.631576); opacity: 0.51; }
  15% { -webkit-transform: translateX(25.8px) scale(0.578944); opacity: 0.44; }
  20% { -webkit-transform: translateX(15.2px) scale(0.526312); opacity: 0.37; }
  25% { -webkit-transform: translateX(0px) scale(0.47368); opacity: 0.3; }
  30% { -webkit-transform: translateX(-15.2px) scale(0.526312); opacity: 0.37; }
  35% { -webkit-transform: translateX(-25.8px) scale(0.578944); opacity: 0.44; }
  40% { -webkit-transform: translateX(-36.4px) scale(0.631576); opacity: 0.51; }
  45% { -webkit-transform: translateX(-47px) scale(0.684208); opacity: 0.58; }
  50% { -webkit-transform: translateX(-50px) scale(0.73684); opacity: 0.65; }
  55% { -webkit-transform: translateX(-47px) scale(0.789472); opacity: 0.72; }
  60% { -webkit-transform: translateX(-36.4px) scale(0.842104); opacity: 0.79; }
  65% { -webkit-transform: translateX(-25.8px) scale(0.894736); opacity: 0.86; }
  70% { -webkit-transform: translateX(-15.2px) scale(0.947368); opacity: 0.93; }
  75% { -webkit-transform: translateX(0px) scale(1); opacity: 1; }
  80% { -webkit-transform: translateX(15.2px) scale(0.947368); opacity: 0.93; }
  85% { -webkit-transform: translateX(25.8px) scale(0.894736); opacity: 0.86; }
  90% { -webkit-transform: translateX(36.4px) scale(0.842104); opacity: 0.79; }
  95% { -webkit-transform: translateX(47px) scale(0.789472); opacity: 0.72; }
  100% { -webkit-transform: translateX(50px) scale(0.73684); opacity: 0.65; }
}

@keyframes orbit {
  0% { transform: translateX(50px) scale(0.73684); opacity: 0.65; }
  5% { transform: translateX(47px) scale(0.684208); opacity: 0.58; }
  10% { transform: translateX(36.4px) scale(0.631576); opacity: 0.51; }
  15% { transform: translateX(25.8px) scale(0.578944); opacity: 0.44; }
  20% { transform: translateX(15.2px) scale(0.526312); opacity: 0.37; }
  25% { transform: translateX(0px) scale(0.47368); opacity: 0.3; }
  30% { transform: translateX(-15.2px) scale(0.526312); opacity: 0.37; }
  35% { transform: translateX(-25.8px) scale(0.578944); opacity: 0.44; }
  40% { transform: translateX(-36.4px) scale(0.631576); opacity: 0.51; }
  45% { transform: translateX(-47px) scale(0.684208); opacity: 0.58; }
  50% { transform: translateX(-50px) scale(0.73684); opacity: 0.65; }
  55% { transform: translateX(-47px) scale(0.789472); opacity: 0.72; }
  60% { transform: translateX(-36.4px) scale(0.842104); opacity: 0.79; }
  65% { transform: translateX(-25.8px) scale(0.894736); opacity: 0.86; }
  70% { transform: translateX(-15.2px) scale(0.947368); opacity: 0.93; }
  75% { transform: translateX(0px) scale(1); opacity: 1; }
  80% { transform: translateX(15.2px) scale(0.947368); opacity: 0.93; }
  85% { transform: translateX(25.8px) scale(0.894736); opacity: 0.86; }
  90% { transform: translateX(36.4px) scale(0.842104); opacity: 0.79; }
  95% { transform: translateX(47px) scale(0.789472); opacity: 0.72; }
  100% { transform: translateX(50px) scale(0.73684); opacity: 0.65; }
}
.slice:nth-child(1)::before,
.slice:nth-child(1)::after {
  background-color: #3a8eff; /* azul vibrante */
}

.slice:nth-child(2)::before,
.slice:nth-child(2)::after {
  background-color: #4b6cff; /* azul brillante */
}

.slice:nth-child(3)::before,
.slice:nth-child(3)::after {
  background-color: #6f4bff; /* azul violeta */
}

.slice:nth-child(4)::before,
.slice:nth-child(4)::after {
  background-color: #944bff; /* morado fuerte */
}

.slice:nth-child(5)::before,
.slice:nth-child(5)::after {
  background-color: #b64bff; /* magenta neón */
}

.slice:nth-child(6)::before,
.slice:nth-child(6)::after {
  background-color: #db4bff; /* rosa púrpura neón */
}

      `}</style>
    </>
  );
};
